import { CreditDocumentUploadResponse, ICreditDocumentUploadRepository } from "@/core/repositories/credit/ICreditDocumentUpload.repository";

export class UploadCreditDocumentUseCase {
  constructor(private readonly creditDocumentUploadRepository: ICreditDocumentUploadRepository) {}

  async execute(file: File): Promise<CreditDocumentUploadResponse> {
    return this.creditDocumentUploadRepository.uploadDocument(file);
  }
}
